module.exports = __webpack_public_path__ + "img/ic_benifit_gold.e4f119ec.png";